module.exports = __webpack_public_path__ + "static/media/yellowcar.8ace4754.png";